export function AdminBookingsPage() {
  return <div className="card text-ink-muted">전체 예약 검색 — 다음 단계 구현 예정</div>;
}
